




























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppUserBillableTargetHistoryEditModel } from '@/services/api/nswag/stapiclient_generated';
import { stAppUserBillableTargetHistoryApi } from '@/services/st-api';
import { ObjectEditor } from '@/utlitities/helper';

@Component({
  components: {},
})
export default class AppUserBillableTargetHistory extends Vue {
  @Prop() appUserId!: number;
  @Prop() value!: AppUserBillableTargetHistoryEditModel[];

  historyItems: ObjectEditor<AppUserBillableTargetHistoryEditModel>[] = [];
  displayWarning = false;

  async mounted() {
    let unwatch = this.$watch('value', () => {
      this.value.forEach((x) => {
        this.historyItems.push(new ObjectEditor<AppUserBillableTargetHistoryEditModel>(x));
        unwatch();
      });
    });
  }

  saveItem(item: ObjectEditor<AppUserBillableTargetHistoryEditModel>) {
    item.editMode = false;
    this.displayWarning = false;
    this.updateOutside();
  }

  cancel(item: ObjectEditor<AppUserBillableTargetHistoryEditModel>, index: number) {
    this.displayWarning = false;
    if (item.isNew) {
      this.remove(index);
    } else {
      item.reset();
    }
  }

  async updateOutside() {
    this.$emit(
      'input',
      this.historyItems.map((x) => x.val)
    );
    await this.$nextTick();
    this.historyItems = [];
    this.value.forEach((x) => {
      this.historyItems.push(new ObjectEditor<AppUserBillableTargetHistoryEditModel>(x));
    });
  }

  get isEditingItem() {
    return this.historyItems.filter((_) => _.editMode).length > 0;
  }

  remove(index: number) {
    this.historyItems.splice(index, 1);
    this.updateOutside();
  }

  async addNewItem() {
    let newItem = await stAppUserBillableTargetHistoryApi.getNew(this.appUserId);
    let newHistoryItem = new ObjectEditor<AppUserBillableTargetHistoryEditModel>(newItem);
    newHistoryItem.editMode = true;
    newHistoryItem.isNew = true;
    this.historyItems.unshift(newHistoryItem);
  }
}
